import { BpTable } from '../../../../shared/components/cards/table/BpTable'
import { ColumnsType } from 'antd/lib/table'
import { useGetReferralUserListQuery } from '../../../../app/api'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'

export const ByReferralTable = () => {
  const { t } = useTranslation()
  const [sort, setSort] = useState<any>()

  const { data, isLoading, isFetching } = useGetReferralUserListQuery()

  const sortedReferrals = useMemo(() => {
    if (!sort?.order || !sort?.columnKey || !data?.data) return data

    const sortedData = [...data.data].sort((a: any, b: any) =>
      sort.order === 'ascend'
        ? a[sort.columnKey] > b[sort.columnKey]
          ? 1
          : -1
        : a[sort.columnKey] < b[sort.columnKey]
          ? 1
          : -1,
    )

    return { ...data, data: sortedData }
  }, [data, sort])

  const columns: ColumnsType<any> = [
    {
      title: t('table.columns.referral'),
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: t('table.columns.registrationDate'),
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
    },
    {
      title: t('table.columns.company'),
      dataIndex: 'company_name',
      key: 'company_name',
    },
    {
      title: t('table.columns.earned'),
      dataIndex: 'earned',
      key: 'earned',
    },
  ]

  const handleTableChange = (sort: any) => {
    setSort({ columnKey: sort?.columnKey, order: sort?.order })
  }

  return (
    <div>
      <BpTable
        columns={columns}
        dataSource={sortedReferrals?.data}
        hidePagination={true}
        loading={isLoading || isFetching}
        scroll={{ x: 420 }}
        onChange={(_pagination, _filter, sorter) => handleTableChange(sorter)}
      />
    </div>
  )
}
